<template>
  <div>
    <div class="text-h6 text--text mb-2">
      Что даёт клуб
    </div>
    <div class="text-body-1 text--text">
      Возможность получить скидку 30% на консультацию у врача по клубному купону.
    </div>
    <div class="text-h6 text--text mt-8 mb-2">
      Как получить купон и скидку
    </div>
    <div class="b-club-list text-body-1 text--text">
      <div class="b-club-list__item">
        Оплатите на сайте ПроДокторов 50% стоимости консультации по клубной цене
      </div>
      <div class="b-club-list__item">
        Получите клубный купон на скидку
      </div>
      <div class="b-club-list__item">
        В день визита оплачиваете в клинике оставшиеся 50%
      </div>
    </div>
    <div class="text-h6 text--text mt-8 mb-2">
      Как вступить в клуб
    </div>
    <div class="text-body-1 text--text mb-4">
      Просто воспользуйтесь клубной ценой и вы станете участником клуба на 6 месяцев.
      После доступ к клубным ценам на 6 месяцев будет стоить 99 ₽.
    </div>

    <v-divider class="my-8" />
    <div class="text-h6 text--text mb-4">
      Вопросы и ответы
    </div>
    <v-expansion-panels multiple>
      <v-expansion-panel
        v-for="(item, index) in expansionPanel"
        :key="`${componentName}ExpansionItem${index}`"
      >
        <v-expansion-panel-header
          :expand-icon="vuetifyIcons.arrowDown"
          class="text-left justify-space-between"
        >
          <span class="text-body-1">{{ item.title }}</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="text-body-1">
          {{ item.description }}
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div class="mt-10 mb-4">
      <div class="text-body-2 text-secondary--text">
        © 2011 — {{ nowYear }}, ООО «МЕДРОКЕТ»
      </div>
      <div class="d-block text-body-2 text-secondary--text mt-2">
        Оплачивая, вы соглашаетесь
        с&nbsp;<a
          :href="pdfData.coupon"
          rel="noopener noreferrer"
          target="_blank"
          class="text-secondary--text"
        >офертой</a>
        и&nbsp;<a
          :href="pdfData.participation"
          rel="noopener noreferrer"
          target="_blank"
          class="text-secondary--text"
        >правилами клуба</a>
      </div>
    </div>
  </div>
</template>

<script>
import vuetify from 'www/modules/vuetify-plugin'
import ClubInfoModalLogic from 'www/vue_components/common/Club/components/dependencies/ClubInfoModal/mixins/ClubInfoModalLogic'
import ClubInfoModalExpansionPanel from 'www/vue_components/common/Club/components/dependencies/ClubInfoModal/mixins/ClubInfoModalExpansionPanel'

export default {
  name: 'ClubDesktopInfoModalContent',
  vuetify,
  mixins: [
    ClubInfoModalLogic,
    ClubInfoModalExpansionPanel,
  ],
}
</script>
